<template>
  <div class="detail-link-payin-trans page-container">
    <div class="page-title">
      Payment Links
    </div>

    <div class="filter-container">
      <div class="custom-breadcrumbs">
        <i class="el-icon-arrow-left icon-back" @click="onClickBackBtn" />
        <span @click="onClickBackBtn">Transaction</span>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >

        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.payment_method')" align="center">
          <template slot-scope="scope">
            <span>{{ getPayinPaymentMethodMap( scope.row.pay_product_type) }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('customerService.payment_code')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_switch_code ? scope.row.payment_switch_code.payment_code : '' }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchant.payment_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getPayTransactionStatusType(scope.row.transaction_status)"> {{ getPayTransactionStatusMap(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_fee && scope.row.payment_fee.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('data.name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.mobile')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_mobile }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('merchantAccount.pay_trans_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column> -->

        <el-table-column min-width="110" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_create_time }}
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <payment-details-modal ref="paymentDetailsModal" :detail-id="detailId" />
  </div>
</template>
<script>

import { fetchPaymentLinkTransDetail, retryDisbursementData } from '@/api/online-transaction/online-transaction'
import { payTransactionStatusMap, payinPaymentMethodMap } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'
export default {
  name: 'Detail_Link_Payin_Trans',
  components: {
    PaymentDetailsModal: () => import('@/views/paycools/data/components/Modal/PayinDetailsModal')
  },
  data() {
    this.statusObj = {
      'Payment_Needs_Validation': 0,
      'Payment_Approved': 1
    }
    return {
      detailId: '0',
      status: null,
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    getPayTransactionStatusType() {
      return function(value) {
        return payTransactionStatusMap(value).type
      }
    },
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusMap(value).label
      }
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    }
  },
  created() {
    this.getPaymentRefernceDetail()
  },
  methods: {
    getPaymentRefernceDetail() {
      this.listLoading = true
      const { rId } = this.$route.query
      const params = {
        row_key: rId
      }

      fetchPaymentLinkTransDetail(params).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data || []
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { payment_status, times = [] } = this.search
      let params = { start_date: times && times[0], end_date: times && times[1], payment_status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getPaymentRefernceDetail(params)
    },
    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },
    showPayDetailModal() {
      this.$refs.paymentDetailsModal.changModalStatus(true)
    },
    onClickPaginator() {

      this.handleFilter(this.listQuery)
    },
    onClickEditBtn(row) {
      this.$refs.singleDisbursementEditModal.changModalStatus({
        status: true,
        value: row
      })
    },
    onClickRetryBtn(row) {
      const params = { row_key: row.row_key }
      retryDisbursementData(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Retry Successfully')
          this.getPaymentRefernceDetail()
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    onClickBackBtn() {
      const { status, id } = this.$route.query
      this.$router.push({ name: 'Online_Transaction_Detail_Payin', params: { status, id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-link-payin-trans{
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .btn-container{
    display: flex;
    justify-content: flex-end;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .btn-download{
    position: absolute;
    right: 40px;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
